import { component } from "picoapp";

export const cartSubscriptionSelector = component((node) => {
  const oneTimePurchaseBtn =
    node.querySelector<HTMLButtonElement>(".rebuy-button");
  const sellingPlanBtn = node.querySelector<HTMLSelectElement>(".rebuy-select");
  const subscriptionInfo = node.querySelector<HTMLParagraphElement>(
    "[data-subscription-info]"
  );
  const regularPriceEl = node.querySelector<HTMLElement>(
    "[data-cart-item-regular-price]"
  );
  const compareAtPriceEl = node.querySelector<HTMLElement>(
    "[data-cart-item-compare-at-price]"
  );
  const cartTotal = document.querySelector<HTMLElement>("[data-cart-subtotal]");

  if (oneTimePurchaseBtn) {
    oneTimePurchaseBtn.addEventListener("click", () => {
      const defaultDeliveryFrequency = sellingPlanBtn.options[2].value;
      sellingPlanBtn.value = defaultDeliveryFrequency;
      subscriptionInfo.innerHTML = sellingPlanBtn.options[2].innerHTML;
      subscriptionInfo.classList.remove("hide");

      const changeEvent = new Event("change");
      sellingPlanBtn.dispatchEvent(changeEvent);
    });
  }

  if (sellingPlanBtn) {
    sellingPlanBtn.addEventListener(
      "change",
      (e: Event & { target: HTMLSelectElement }) => {
        try {
          const lineItem = window.Rebuy.Cart.items().find(
            (lineItem) => lineItem.key === node.dataset.cartItemKey
          );
          const lineItemIndex = window.Rebuy.Cart.items().findIndex(
            (lineItem) => lineItem.key === node.dataset.cartItemKey
          );

          if (!lineItem) return;

          window.Rebuy.Cart.changeItem(
            {
              id: node.dataset.cartItemKey,
              quantity: lineItem.quantity,
              selling_plan: e.target.value,
            },
            {
              success: (cart) => {
                const matchedLineItem = cart.items[lineItemIndex];
                const newKey = matchedLineItem.key;
                node.setAttribute("data-cart-item-key", newKey);

                const updatedCartTotal = "$" + cart.items_subtotal_price / 100;
                const updatedCartCurrency = cart.currency;
                cartTotal.innerHTML =
                  updatedCartTotal + " " + updatedCartCurrency;

                const sellingPlan = matchedLineItem?.selling_plan_allocation;
                if (sellingPlan) {
                  regularPriceEl.innerHTML = "$" + sellingPlan.price / 100;
                  compareAtPriceEl.innerHTML =
                    "$" + sellingPlan.compare_at_price / 100;
                  subscriptionInfo.innerHTML = sellingPlan.selling_plan.name;
                  sellingPlanBtn.style.display = "block";
                  oneTimePurchaseBtn.style.display = "none";
                } else {
                  regularPriceEl.innerHTML =
                    "$" + matchedLineItem.final_price / 100;
                  subscriptionInfo.classList.remove("hide");
                  subscriptionInfo.innerHTML = "";
                  compareAtPriceEl.innerHTML = "";
                  oneTimePurchaseBtn.style.display = "block";
                  sellingPlanBtn.style.display = "none";
                }
              },
            }
          );
        } catch (error) {
          console.error(error);
        }
      }
    );
  }
});
